import { useState } from 'react';
import { CustomModal, Typography } from 'seagull';
import VerifyNewEmail from "./VerifyNewEmail/VerifyNewEmail";
import styles from "./ChangeEmailAddress.module.scss";
import { ViewType } from "./ChangeEmailAddressTypes";
import EnterOneTimePassword from "./EnterOneTimePassword/EnterOneTimePassword";
import ManyAttemptsError from "./ManyAttemptsError/ManyAttemptsError";
import SetUpNewEmail from "./SetUpNewEmail/SetUpNewEmail";
import { jsx as _jsx } from "react/jsx-runtime";
function ChangeEmailAddressModal(_ref) {
  let {
    onClose
  } = _ref;
  const [view, setView] = useState(ViewType.EnterOneTimePassword);
  const [newUserEmail, setNewUserEmail] = useState('');
  const handleSetView = view => {
    setView(view);
  };
  const getViewContent = () => {
    switch (view) {
      case ViewType.EnterOneTimePassword:
        return /*#__PURE__*/_jsx(EnterOneTimePassword, {
          handleSetView: handleSetView,
          onClose: onClose
        });
      case ViewType.SetUpNewEmail:
        return /*#__PURE__*/_jsx(SetUpNewEmail, {
          handleSetView: handleSetView,
          onClose: onClose,
          handleSetNewEmail: setNewUserEmail
        });
      case ViewType.VerifyNewEmail:
        return /*#__PURE__*/_jsx(VerifyNewEmail, {
          handleSetView: handleSetView,
          handleClose: onClose,
          newUserEmail: newUserEmail
        });
      case ViewType.TooManyAttempts:
        return /*#__PURE__*/_jsx(ManyAttemptsError, {
          onClose: onClose
        });
    }
  };
  return /*#__PURE__*/_jsx(CustomModal, {
    width: "660px",
    "data-testid": "change-email-address-modal",
    title: "Change Email Address",
    onClose: onClose,
    headerClassName: styles.header,
    header: /*#__PURE__*/_jsx(Typography, {
      className: styles.header,
      variant: "h6",
      weight: "bold",
      children: "Change email address"
    }),
    children: getViewContent()
  });
}
export default ChangeEmailAddressModal;